export default __webpack_public_path__ + "static/media/successful-submit-icon.3a738ea5.svg";